import React, { memo, useEffect, useState } from 'react'
import { TextField } from '@material-ui/core'
// eslint-disable-next-line import/named
import { FieldHookConfig, useField } from 'formik'
import { usePropagateRef } from '../../../../common/use-propagate-ref'
import { isFractal, isInteger } from '@plandi/common/src/utils/regex-check'

export type PerformantTextFieldProps = {
  name: string | FieldHookConfig<never>
  type?: string
  label?: string
  placeholder?: string
  fullWidth?: boolean
  className?: string
  variant?: 'standard' | 'filled' | 'outlined' | undefined
  margin?: 'none' | 'dense' | 'normal'
  value?: string | number | null | undefined
  onChangePar?: string | undefined
  helperText?: string | string[] | undefined
  error?: boolean
  disabled?: boolean
  disablePerformance?: boolean
  loading?: boolean
  min?: number
  max?: number
  InputProps?: { endAdornment: JSX.Element }
}

export const PerformantTextField: React.FC<PerformantTextFieldProps> = memo(
  (props) => {
    const [field, meta] = useField(props.name)

    const [fieldValue, setFieldValue] = useState<
      string | number | null | undefined
    >(field.value)

    usePropagateRef({
      setFieldValue,
      name: props.name,
      value: field.value
    })

    useEffect(() => {
      if (meta.touched) {
        return
      }
      if (field.value !== fieldValue) {
        setFieldValue(field.value)
      }
      // eslint-disable-next-line
    }, [field.value])

    const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
      if (props.onChangePar === 'isInteger') {
        if (!evt.target.value || isInteger(evt.target.value)) {
          setFieldValue(evt.target.value)
        }
      }
      if (props.onChangePar === 'isFractal') {
        if (!evt.target.value || isFractal(evt.target.value)) {
          setFieldValue(evt.target.value)
        }
      }
      if (!props.onChangePar) {
        setFieldValue(evt.target.value)
      }
    }

    const onBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
      const val = evt.target.value || ''
      window.setTimeout(() => {
        field.onChange({
          target: {
            name: props.name,
            value: props.type === 'number' ? parseInt(val, 10) : val
          }
        })
      }, 0)
    }

    return (
      <>
        <TextField
          label={props.label}
          placeholder={props.placeholder}
          fullWidth
          className={props.className}
          variant={props.variant}
          margin={props.margin}
          type={props.type}
          helperText={props.helperText}
          InputProps={props.InputProps}
          error={props.error}
          disabled={props.disabled}
          {...{
            ...field,
            value: fieldValue ?? props.value,
            onChange,
            onBlur,
            onFocus: onBlur
          }}
        />
      </>
    )
  }
)
